'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _address = require('../../api/address');

var _countries = require('../../utils/countries');

var _countries2 = _interopRequireDefault(_countries);

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _inputSearch = require('constructicon/input-search');

var _inputSearch2 = _interopRequireDefault(_inputSearch);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddressSearch = function (_Component) {
  _inherits(AddressSearch, _Component);

  function AddressSearch(props) {
    _classCallCheck(this, AddressSearch);

    var _this = _possibleConstructorReturn(this, (AddressSearch.__proto__ || Object.getPrototypeOf(AddressSearch)).call(this, props));

    _this.handleQuery = _this.handleQuery.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.state = {
      country: props.country || '',
      results: [],
      status: null,
      value: null
    };
    return _this;
  }

  _createClass(AddressSearch, [{
    key: 'handleQuery',
    value: function handleQuery(q) {
      var _this2 = this;

      Promise.resolve().then(function () {
        return _this2.setState({ status: 'fetching' });
      }).then(function () {
        return (0, _address.searchAddress)(q, _this2.state.country);
      }).then(function (results) {
        return _this2.setState({ results: results, status: 'fetched' });
      }).catch(function (error) {
        _this2.setState({ status: 'failed' });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(selected) {
      var _this3 = this;

      this.setState({ value: selected && selected.label });
      if (selected && selected.id) {
        (0, _address.getAddressDetails)(selected.id, this.state.country).then(function (address) {
          return (0, _address.deserializeAddress)(address);
        }).then(function (address) {
          address.country = _this3.state.country;
          _this3.props.onChange(address);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          error = _props.error,
          inputProps = _props.inputProps,
          validations = _props.validations;
      var _state = this.state,
          country = _state.country,
          results = _state.results,
          status = _state.status,
          value = _state.value;


      return _react2.default.createElement(
        _grid2.default,
        { spacing: { x: 0.5 } },
        !this.props.country && _react2.default.createElement(
          _gridColumn2.default,
          { md: 4 },
          _react2.default.createElement(_inputSelect2.default, {
            label: 'Country',
            name: 'address-country',
            onBlur: function onBlur(country) {
              return _this4.setState({ country: country });
            },
            onChange: function onChange(country) {
              return _this4.setState({ country: country });
            },
            options: _countries2.default,
            placeholder: 'Select Country',
            value: country
          })
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          { md: this.props.country ? 12 : 8 },
          _react2.default.createElement(_inputSearch2.default, _extends({
            autoComplete: 'nope',
            error: error,
            label: this.renderLabel(),
            onChange: this.handleSelect,
            onSearch: this.handleQuery,
            results: results,
            showMore: true,
            status: status,
            validations: validations,
            value: value
          }, inputProps))
        )
      );
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _props2 = this.props,
          onCancel = _props2.onCancel,
          onCancelLabel = _props2.onCancelLabel,
          required = _props2.required;


      return _react2.default.createElement(
        _grid2.default,
        { spacing: { x: 0.5 } },
        _react2.default.createElement(
          _gridColumn2.default,
          { xs: 5 },
          _react2.default.createElement(
            'span',
            null,
            'Address'
          ),
          required && _react2.default.createElement(
            _section2.default,
            { foreground: 'danger', spacing: 0, tag: 'span' },
            '*'
          )
        ),
        onCancel && _react2.default.createElement(
          _gridColumn2.default,
          { xs: 7, xsAlign: 'right' },
          _react2.default.createElement(
            _button2.default,
            {
              background: 'transparent',
              borderWidth: 0,
              foreground: 'inherit',
              onClick: onCancel,
              size: -1.5,
              spacing: 0
            },
            onCancelLabel
          )
        )
      );
    }
  }]);

  return AddressSearch;
}(_react.Component);

AddressSearch.propTypes = {
  /**
   * Country for API queries
   */
  country: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * The props to pass to the input search component
   */
  inputProps: _propTypes2.default.object,

  /**
   * The onCancel function to call when the user wants to enter address manually
   */
  onCancel: _propTypes2.default.func,

  /**
   * The text label from the 'Enter manually' button
   */
  onCancelLabel: _propTypes2.default.string,

  /**
   * The onChange function to call when a selection is made
   */
  onChange: _propTypes2.default.func.isRequired
};

AddressSearch.defaultProps = {
  onCancelLabel: 'Enter manually'
};

exports.default = AddressSearch;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/address-search/index.js
// module id = 1427
// module chunks = 0